// extracted by mini-css-extract-plugin
export default {"wrapper":"need-terminal_wrapper--Wy90r","emoji":"need-terminal_emoji--bLS09","content":"need-terminal_content--CZ3ME","actions":"need-terminal_actions--jmA2N"};